export default "__VITE_ASSET__B6Qk5RWy__"